import { useQuery } from "@tanstack/react-query";
import * as api from "../../api/client";
import type { ApiCtx } from "../../api/client";
import { texte } from "../../texte";

type CritiqueBlock = { cid: string; verdict: "ok" | "rejected"; target: string; text: string; action: string; timestamp: string };

/** `/critiques` liefert Markdown; Blöcke per Regex splitten (client.md §9.3). */
function parseCritiques(markdown: string): CritiqueBlock[] {
  const blocks: CritiqueBlock[] = [];
  const headerRe = /^## (C\d+) \((ok|rejected|abgelehnt)\) — (?:target|Ziel): (\S+) at (\S+)\r?$/gm;
  const matches = [...markdown.matchAll(headerRe)];
  for (let i = 0; i < matches.length; i++) {
    const m = matches[i];
    const start = (m.index ?? 0) + m[0].length;
    const end = i + 1 < matches.length ? (matches[i + 1].index ?? markdown.length) : markdown.length;
    const body = markdown.slice(start, end);
    const text = body.match(/(?:Critique|Kritik):\s*(.*)/)?.[1]?.trim() ?? "";
    const action = body.match(/(?:Action|Aktion):\s*(.*)/)?.[1]?.trim() ?? "";
    const verdict = (m[2] === "abgelehnt" ? "rejected" : m[2]) as "ok" | "rejected";
    blocks.push({ cid: m[1], verdict, target: m[3], text, action, timestamp: m[4] });
  }
  return blocks;
}

export function Critiques({ ctx, critiqueEnabled }: { ctx: ApiCtx; critiqueEnabled: boolean }) {
  const query = useQuery({
    queryKey: ["critiques", ctx.apiUrl, ctx.token, ctx.workspace],
    queryFn: () => api.critiques(ctx),
  });
  const content = query.data?.content ?? "";
  const blocks = content ? parseCritiques(content) : [];

  if (!blocks.length) {
    return (
      <div className="empty" style={{ maxWidth: 560 }}>
        {critiqueEnabled ? texte.critiques.emptyActive : texte.critiques.emptyInactive}
      </div>
    );
  }

  return (
    <>
      {blocks.map((c) => (
        <div className="critic-block" key={c.cid}>
          <div className="ch">
            <span className="cid">{c.cid}</span>
            <span className={`verdict ${c.verdict === "ok" ? "ok" : "rej"}`}>
              {c.verdict === "ok" ? texte.critiques.ok : texte.critiques.rejected}
            </span>
            <span className="tgt">
              {texte.critiques.target} {c.target}
            </span>
            <span className="tgt">
              {c.timestamp}
            </span>
          </div>
          <p style={{ fontSize: 13.5 }}>{c.text}</p>
          <p className="act">
            {texte.critiques.action} {c.action}
          </p>
        </div>
      ))}
    </>
  );
}
